import React from 'react';
import Text from '@amzn/meridian/text';
import { FormattedMessage } from 'react-intl';
import { ARCFilters, SIDE_MENU_PATH } from '../Types/types';

interface FilterDescriptionProps {
  filter: string;
  vertical: string;
  hash: string;
  allTmCount: number;
  allAssociateCount: number;
  directReportCount: number;
  sharedProfileCount: number;
}

const FilterDescription: React.FC<FilterDescriptionProps> = ({
  filter,
  vertical,
  hash,
  allTmCount,
  allAssociateCount,
  directReportCount,
  sharedProfileCount,
}: FilterDescriptionProps): React.ReactElement => {
  if (
    (hash === SIDE_MENU_PATH.ALL_TMS && allTmCount === 0) ||
    (hash === SIDE_MENU_PATH.ALL_ASSOCIATES && allAssociateCount === 0) ||
    (hash === SIDE_MENU_PATH.DIRECT_REPORT && directReportCount === 0) ||
    (hash === SIDE_MENU_PATH.SHARED_PROFILE && sharedProfileCount === 0)
  ) {
    return <></>;
  }

  if (filter === ARCFilters.PERFORMANCE) {
    return vertical ? (
      <Text type='b400' data-cy='performance-description'>
        <FormattedMessage
          id='cs_perfportal_performance_desc'
          defaultMessage='Performance data is calculated week over week.'
        />
      </Text>
    ) : (
      <></>
    );
  }
  if (filter === ARCFilters.COACHINGS) {
    return <></>;
  }
  if (filter === ARCFilters.OPPORTUNITIES) {
    return (
      <Text type='b400' data-cy='opportunities-description'>
        <FormattedMessage
          id='cs_perfportal_arc_opportunity_desc'
          defaultMessage='Opportunities are from the past 7 days.'
        />
      </Text>
    );
  }
  if (filter === ARCFilters.KUDOS) {
    return (
      <Text type='b400' data-cy='kudos-description'>
        <FormattedMessage
          id='cs_perfportal_arc_kudos_desc'
          defaultMessage='Kudos are from the past 7 days.'
        />
      </Text>
    );
  }
  if (filter === ARCFilters.GOALS) {
    return (
      <Text type='b400' data-cy='goals-description'>
        <FormattedMessage
          id='cs_perfportal_arc_goals_desc'
          defaultMessage="Associate's the most recent, active goals."
        />
      </Text>
    );
  }
  return <></>;
};

export default FilterDescription;
